import $ from 'jquery'
window.$ = window.jQuery = $

$.extend($.validator.messages, {
  required: 'Ce champ est requis.',
  remote: 'Veuillez corriger ce champ.',
  email: "S'il vous plaît, mettez une adresse email valide.",
  url: 'Veuillez saisir une URL valide.',
  date: 'Veuillez entrer une date valide.',
  dateISO: 'Veuillez entrer une date valide (ISO).',
  number: "S'il vous plait, entrez un nombre valide.",
  digits: "Merci de n'entrer que des chiffres.",
  equalTo: "Entrez à nouveau la même valeur s'il vous plait.",
  maxlength: $.validator.format('Veuillez ne pas saisir plus de {0} caractères.'),
  minlength: $.validator.format('Veuillez saisir au moins {0} caractères.'),
  rangelength: $.validator.format('Veuillez saisir une valeur comprise entre {0} et {1} caractères.'),
  range: $.validator.format('Veuillez entrer une valeur entre {0} et {1}.'),
  max: $.validator.format('Veuillez entrer une valeur inférieure ou égale à {0}.'),
  min: $.validator.format('Veuillez saisir une valeur supérieure ou égale à {0}.'),
  step: $.validator.format('Veuillez entrer un multiple de {0}.'),
})

